// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1N0gs","basket":"style_basket__1AvhA","description":"style_description__NCINq"};